const CURRENCY_SYMBOL = '€'
/**
 * Append the currency symbol and round to 2 decimal position
 * @param value
 * @returns
 */
export const appendCurrencySymbol = (value: number): string => {
  if (isNaN(value)) return ''
  return `${value.toFixed(2)} ${CURRENCY_SYMBOL}`
}

/**
 * Prepend the currency symbol and round to 2 decimal position
 * @param value
 * @returns
 */
export const prependCurrencySymbol = (value: number): string => {
  if (isNaN(value)) return ''
  return `${CURRENCY_SYMBOL} ${value.toFixed(2)}`
}

/**
 * Remove the currency symbol
 * @param value
 * @returns
 */
export const removeCurrencySymbol = (value: string) => {
  return value.replace(CURRENCY_SYMBOL, '')
}
